import Links from "../../components/elements/Links";
import Message from "../../components/Message";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {login, reset} from "../../slices/authSlice";
import {profile} from "../../slices/userSlice";


const Login = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = {
      email,
      password,
    };

    await dispatch(login(user));
    await dispatch(profile());
  };

  useEffect(() => {
    dispatch(reset());
  }, [dispatch]);

  return (
    <>
    <div className="absolute inset-0 bg-black opacity-50"></div>
    <div className="min-h-dvh relative z-10 px-6 pt-10 pb-12 sm:mx-auto sm:max-w-lg sm:rounded-lg content-center">
      <form onSubmit={handleSubmit} className="bg-verde-oliva border-verde-musgo bg-opacity-85 sm:rounded-lg content-center border-solid shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <h2 className="font-special text-center block mb-2 text-2xl font-bold text-gray-900 dark:text-white">Entrar no jogo</h2>
        <div className="mb-4">
          <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">
            E-mail
          </label>
          <input onChange={(e) => setEmail(e.target.value)} value={email || ""} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" type="email" placeholder="eu@eu.com" />
        </div>
        <div className="mb-6">
          <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">
            Senha
          </label>
          <input onChange={(e) => setPassword(e.target.value)} value={password || ""} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" type="password" placeholder="*******" />
        </div>
        <div className="flex items-center justify-between">
          {!loading && <input type="submit" className="text-white bg-bordo hover:bg-cinza-cl-900 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-auto px-5 py-2.5 text-center" value="Entrar" />}
          {loading && <input type="submit" className="text-white bg-bordo hover:bg-cinza-cl-900 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled value="Aguarde..." />}
          <Links linkProp={{pag: "/Register", dsLink: "Não tenho uma conta", type: "D"}} />
        </div>
      </form>
      {error && <Message type={"error"} msg={error} />}
    </div>
    </>
  )
}

export default Login